'use client';

import { useEffect } from 'react';

const STREAMED_ICON_SELECTOR = 'link[rel~="icon"][data-streamed]';

function getLatestStreamedFaviconHref(): string | null {
  const icons = document.querySelectorAll<HTMLLinkElement>(STREAMED_ICON_SELECTOR);
  for (let index = icons.length - 1; index >= 0; index -= 1) {
    const href = icons[index]?.getAttribute('href');
    if (href) return href;
  }

  return null;
}

function applyFaviconToHead(href: string): void {
  const existing = document.head.querySelector<HTMLLinkElement>('link[rel~="icon"]');
  if (existing) {
    if (existing.getAttribute('href') !== href) {
      existing.setAttribute('href', href);
    }
    return;
  }

  const link = document.createElement('link');
  link.rel = 'icon';
  link.setAttribute('href', href);
  document.head.appendChild(link);
}

function syncStreamedFavicon(): void {
  const href = getLatestStreamedFaviconHref();
  if (href) {
    applyFaviconToHead(href);
  }
}

export default function StreamedFaviconBridge() {
  useEffect(() => {
    syncStreamedFavicon();

    const observer = new MutationObserver(() => {
      syncStreamedFavicon();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href', 'rel', 'data-streamed'],
    });

    return () => observer.disconnect();
  }, []);

  return null;
}
